module.exports = __webpack_public_path__ + "img/product01.d53956d2.png";